import { render } from "./ProblemsElement.vue?vue&type=template&id=a67c0a10"
import script from "./ProblemsElement.vue?vue&type=script&lang=js"
export * from "./ProblemsElement.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__